export const FLAG_REASON_ABUSIVE = 'abusive'
export const FLAG_REASON_OTHER = 'other'
export const FLAG_REASON_SPAM = 'spam'

export const FLAG_MINIMUM_QUERY_LENGTH = 5
